import * as d3 from 'd3';
import React from 'react';
import ReactDOM from 'react-dom/client';

import {Sequence} from 'components/Sequence';
import {PolymerLinearMapState} from 'molbio/maps/MapStates';
import ModifiedNucleotidesLegend from 'molbio/monomers/ModifiedNucleotidesLegend';
import {renderToStaticMarkup} from 'redux-stores/ReduxDOMRender';

export interface ModifiedNucleotidesLegendViewOptions extends Backbone.ViewOptions<Backbone.Model> {
  mapstate: PolymerLinearMapState<Sequence>;
}

/**
 * N.B. This view is used exclusively for exports
 */
export class ModifiedNucleotidesLegendView extends Backbone.View<Backbone.Model> {
  mapstate!: PolymerLinearMapState<Sequence>;
  reactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.tagName = 'svg';
  }

  override initialize(options: ModifiedNucleotidesLegendViewOptions): void {
    this.mapstate = options.mapstate;
  }

  override render(): this {
    this.$el.html(
      renderToStaticMarkup(
        <ModifiedNucleotidesLegend sequenceId={this.mapstate.get('sequence').get('id')} svgOnly={true} />
      )
    );
    const legendEl = this.$el.find('.modifiedNucleotidesLegend')[0];
    d3.select(this.el).attr('height', legendEl?.getAttribute('height') ?? '');
    return this;
  }

  override remove(): Backbone.View<Backbone.Model> {
    return this.remove();
  }
}
ModifiedNucleotidesLegendView.initClass();
